<template>
  <div class="header_wrap">
    <div class="header clearfix">
      <div :style="{backgroundImage: 'url(' + logo + ')'}" class="logo float_left"></div>
      <div class="float_left">
        <el-menu
          :default-active="menuActive"
          class="el-menu-demo h_60"
          mode="horizontal"
          background-color="#2e5597"
          text-color="#fff"
          active-text-color="#2cc6ff"
        >
          <template v-for="item in menuList">
            <el-menu-item
              :index="item.index"
              :key="item.router"
              @click="routerTo(item)"
            >{{item.name}}</el-menu-item>
          </template>
          <el-menu-item
            @click="toCrm"
            index="4"
          >CRM</el-menu-item>
          <el-menu-item
            @click="routerTo({router:'/user'})"
            index="5"
            v-if="isLogin"
          >用户中心</el-menu-item>
          <el-dropdown
          >
            <span class="el-dropdown-link">
              <el-menu-item
                @click="routerTo({router:'/login'})"
                v-if="!isLogin"
                index="6"
                class="h_60 lh_60"
              >
                登录
              </el-menu-item>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="flex justify_center">
                  <el-button
                    @click="isService"
                    type="text"
                  >服务商登录</el-button>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="flex justify_center">
                  <el-button
                    @click="isUser"
                    type="text"
                  >客户登录</el-button>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="flex justify_center">
                  <el-button
                    @click="isFreight"
                    type="text"
                  >货代服务商登录</el-button>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-menu-item
            @click="toManage"
            index="7"
          >管理系统</el-menu-item>
        </el-menu>
      </div>
      <div v-if="isLogin" class="user_area vertical_middle float_right h_60">
        <!-- <div class="msg inline_block">
          <i class="el-icon-bell fontSize_28 color_fff"></i>
          <div class="msg_num text_center color_fff">99+</div>
        </div> -->
        <el-dropdown trigger="click">
          <div class="user_info vertical_middle">
            <img src="/static/img/login_user.png" alt="" class="user_img inline_block">
            <p class="user_name inline_block color_fff">{{user.username}}</p>
            <div class="arrow_wrap inline_block">
              <i class="el-icon-arrow-down color_fff"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button
                @click="handleQuit"
                type="text"
              >退出</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config.js';
export default {
  computed: {
    onRoutes() {
      window.scrollTo(0, 0);
      return this.$route.path.replace("/", "");
    },
  },
  data() {
    return {
      logo: `${config.homeImgBaseUrl}/logo.png`,
      user: {},
      isLogin: false,
      menuActive: "1",
      menuList: [
        {
          name: "首页",
          router: "/Home/HomePage",
          index: '1',
        },
        {
          name: "产品",
          router: "/Home/Product",
          index: '2',
        },
        {
          name: "服务",
          router: "/Home/ServerCenter",
          index: '3',
        },
        {
          name: "选品中心",
          router: "/Home/MallCenter",
          index: '8',
        },
      ]
    };
  },
  watch: {
    '$route': 'routerChange',
  },
  created(){
    this.user = JSON.parse(sessionStorage.getItem('user')) || '';
    this.isLogin = sessionStorage.getItem('isLogin');
    this.tabChange();
  },
  methods: {
    toManage(){
      window.open('https://b.qzztcn.com/login')
    },
    toCrm(){
      window.open('http://crm.qzztcn.cn/login.php')
    },
    isService(){
      // this.$emit('isService');
      this.$router.push({
        path:'/login',
        query: {
          type: 3
        }
      })
    },
    isUser(){
      // this.$emit('isUser');
     this.$router.push({
       path:'/login',
        query: {
          type: 2
        }
     })
    },
    isFreight(){
      // this.$emit('isFreight');
      this.$router.push({
        path:'/login',
        query: {
          type: 4
        }
      })
    },
    routerChange(){
      // 监听页面变化，找到蓝色下滑线应该在哪里
      this.tabChange();
      // user从服务商变为客户，改变用户昵称
      this.user = JSON.parse(sessionStorage.getItem('user')) || '';
    },
    tabChange(){
      let path = this.$route.path;
      if(path == '/login'){
        this.menuActive = '5';
        return;
      }
      if(path == '/Home/HomePage'){
        this.menuActive = '1';
        return;
      }
      if(path == '/Home/Product'){
        this.menuActive = '2';
        return;
      }
      if(path == '/Home/MallCenter' || path == '/Home/MallDetail'){
        this.menuActive = '8';
        return;
      }
      if(path == '/Home/ServerCenter'||path.indexOf('ServeMessage')){
        this.menuActive = '3';
        return;
      }
      if(path.indexOf('user') > -1){
        this.menuActive = '4';
        return;
      }
    },
    handleQuit(){
      this.isLogin = sessionStorage.clear();
      this.$router.push('/login');
    },
    routerTo(item) {
      this.$router.push(item.router);
    }
  }
};
</script>

<style scoped>
.lh_60{
  line-height: 60px;
}

.logo{
  width: 246px;
  height: 60px;
  margin-right: 20px;
  background-repeat: no-repeat;
  background-position-y: calc((60px - 35px) / 2);
}

.header{
  width: 1200px;
  margin: 0 auto;
}

.user_login{
  padding: 0 20px;
  line-height: 60px;
}

.header_wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #2e5597;
  z-index: 100;
}

.h_60{
  height: 60px;
}

.user_info{
  display: inline-block;
  vertical-align: middle;
  padding: 0 10px;
}

.user_img{
  width: 20px;
  height: 19px;
  vertical-align: middle;
}

.msg{
  position: relative;
  margin: 0 20px;
  vertical-align: middle;
}

.msg_num{
  position: absolute;
  top: 0;
  right: 0;
  width: 22px;
  height: 22px;
  margin-top: -11px;
  margin-right: -11px;
  font-size: 12px;
  line-height: 22px;
  background-color: #e74c3c;
  border-radius: 50%;
}

.user_name{
  margin: 0 5px;
  vertical-align: middle;
}

.arrow_wrap{
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue